import React from 'react'
import PropTypes from 'prop-types'
import useEmblaCarousel from 'embla-carousel-react'
import styled from 'styled-components'
import OfferCard, { OfferCardPropTypes } from '../OfferCard'
import media from '../../utils/style'

const SLIDE_SPACING = '20px'

const CarouselWrapper = styled.div`
  width: 100%;
  max-width: 1210px;
  padding: 40px 0 50px 20px;
  margin-left: auto;
  margin-right: auto;

  ${media.MediumScreenUp`
    padding: 50px 0 60px 32px;
  `}

  ${media.LargeScreenUp`
    padding: 70px 32px 90px;
  `}
`

const CarouselTitle = styled.h2`
  margin: 0;
  font-size: 1.25rem;
  padding-bottom: 24px;

  ${media.MediumScreenUp`
    padding-bottom: 32px;
  `}
`

const Carousel = styled.div`
  overflow: hidden;
`

const CarouselContainer = styled.div`
  display: flex;
  touch-action: pan-y;
  backface-visibility: hidden;
  margin-left: calc(${SLIDE_SPACING} * -1);
`

const CarouselSlide = styled.div`
  flex: 0 0 33.333%;
  min-width: 300px;
  padding-left: ${SLIDE_SPACING};
  display: flex;
`

const OfferCardCarousel = ({ offers, title }) => {
  const [emblaRef] = useEmblaCarousel({
    containScroll: 'trimSnaps',
    skipSnaps: true
  })

  return (
    <CarouselWrapper>
      <CarouselTitle>{title || 'Unmissable special offers'}</CarouselTitle>
      <Carousel ref={emblaRef}>
        <CarouselContainer>
          {offers.map((offer) => (
            <CarouselSlide key={offer.id}>
              <OfferCard {...offer} />
            </CarouselSlide>
          ))}
        </CarouselContainer>
      </Carousel>
    </CarouselWrapper>
  )
}

OfferCardCarousel.propTypes = {
  title: PropTypes.string,
  offers: PropTypes.arrayOf(PropTypes.shape(OfferCardPropTypes))
}

export default OfferCardCarousel
